import moment from "moment"
import { mapGetters } from "vuex"

export const formatDateTime = {
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    formatDateTime: function (stringDate, replaceNoDateWith = "") {

      var dateTimeMins = ["1/1/0001 12:00:00 AM", "0001-01-01T00:00:00"];
      if (stringDate == null || stringDate == undefined || dateTimeMins.includes(stringDate)) {
        return replaceNoDateWith;
      }
      if (!this.user || !this.user.DateFormatString) {
        return this.dateString
      }

      try {
        var result = new Date(stringDate).toLocaleDateString();
        return result;
      }
      catch (error) {
        return replaceNoDateWith;
      }
    },

    // Convert to user's local date time
    getLocalDateTime(dateTime, isUtc) {
      let localDate;
      let format = "MM/DD/YYYY h:mm A";
      dateTime = new Date(dateTime).toISOString();

      if (this.user && this.user.DateFormatString) {
        format = this.user.DateFormatString + " h:mm A";
      }
      if (isUtc) {
        localDate = new moment.utc(dateTime).format(format);
        return localDate.isValid() ? localDate.utc().local().format(format) : localDate;
      }
      else {
        localDate = new moment(dateTime);
        return localDate.isValid() ? localDate.local().format(format) : localDate;
      }
    },
    getLocalDate(dateTime) {
      let localDate = new moment.utc(dateTime)
      if (localDate.isValid()) {
        return localDate.utc().local().format("l")
      }
      return "";
    },
    getTimeAgo(stringDate) {
      return moment(stringDate).fromNow();
    },
    formatDecimalDate(dateString) {
      let format = "DD.MM.YYYY"
      return moment(dateString).format(format);
    },
    getNextDay(dateString) {
      var date = new Date(dateString)
      date.setDate(date.getDate() + 1);
      return this.getLocalDate(date);
    },
    isCurrentTimeInRange(startTime, endTime) {
      const currentTime = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
      const currentDateTime = new Date(currentTime);

      if (!startTime && !endTime) {
        return true;
      }

      if (!startTime) {
        const endDateTime = new Date(endTime);
        return currentDateTime <= endDateTime;
      }

      if (!endTime) {
        const startDateTime = new Date(startTime);
        return currentDateTime >= startDateTime;
      }

      const startDateTime = new Date(startTime);
      const endDateTime = new Date(endTime);

      return currentDateTime >= startDateTime && currentDateTime <= endDateTime;
    },
  }
}
